import React, { useState } from 'react';
import { Box, Button, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const BOT = () => {
    const [bottles, setBottles] = useState([]);
    const [bottleDetails, setBottleDetails] = useState({
        id: '',
        name: '',
        quantity: '',
        price: '',
        status: 'Available',
        image: ''
    });
    const [editIndex, setEditIndex] = useState(-1);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBottleDetails({ ...bottleDetails, [name]: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBottleDetails({ ...bottleDetails, image: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAddBottle = () => {
        if (editIndex >= 0) {
            const updatedBottles = [...bottles];
            updatedBottles[editIndex] = bottleDetails;
            setBottles(updatedBottles);
            setEditIndex(-1);
        } else {
            setBottles([...bottles, bottleDetails]);
        }
        setBottleDetails({
            id: '',
            name: '',
            quantity: '',
            price: '',
            status: 'Available',
            image: ''
        });
    };

    const handleEdit = (index) => {
        setBottleDetails(bottles[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setBottles(bottles.filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Bottle of Order (BOT) Management
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        fullWidth
                        label="ID"
                        name="id"
                        value={bottleDetails.id}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={bottleDetails.name}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        fullWidth
                        label="Quantity"
                        name="quantity"
                        value={bottleDetails.quantity}
                        onChange={handleChange}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        fullWidth
                        label="Price"
                        name="price"
                        value={bottleDetails.price}
                        onChange={handleChange}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                            name="status"
                            value={bottleDetails.status}
                            onChange={handleChange}
                            label="Status"
                        >
                            <MenuItem value="Available">Available</MenuItem>
                            <MenuItem value="Out of Stock">Out of Stock</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ width: '100%' }}
                    />
                    {bottleDetails.image && (
                        <img
                            src={bottleDetails.image}
                            alt="Preview"
                            style={{ width: '100%', marginTop: '10px' }}
                        />
                    )}
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddBottle}
                        sx={{ mt: 2, display: 'block', margin: '0 auto', backgroundColor: 'orange' }}
                    >
                        {editIndex >= 0 ? 'Save Bottle' : 'Add Bottle'}
                    </Button>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Image</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bottles.map((bottle, index) => (
                            <TableRow key={index}>
                                <TableCell>{bottle.id}</TableCell>
                                <TableCell>{bottle.name}</TableCell>
                                <TableCell>{bottle.quantity}</TableCell>
                                <TableCell>{bottle.price}</TableCell>
                                <TableCell>{bottle.status}</TableCell>
                                <TableCell>
                                    {bottle.image && (
                                        <img
                                            src={bottle.image}
                                            alt="Preview"
                                            style={{ width: '100px', height: 'auto' }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEdit(index)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDelete(index)} color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BOT;
